import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo4.mp4';

export default {
  banner: {
    title: 'Quản lý quy trình sản xuất theo thời gian thực',
    desc: 'Cho phép nắm bắt tổng quan và quản lý dòng chảy hoạt động của cơ sở sản xuất. Thông qua dữ liệu chính xác và khách quan, có thể cải thiện dây chuyền sản xuất và nâng cao hiệu quả. Đây là yếu tố cốt lõi của ngành sản xuất.',
  },

  video: {
    title: 'Theo dõi mọi khía cạnh của quy trình sản xuất.',
    desc: 'Công nghệ theo dõi vị trí thời gian thực (RTLS) cho phép nắm bắt quy trình sản xuất theo thời gian thực.<br/>Bằng cách nắm bắt tình hình hiện tại của dây chuyền sản xuất theo thời gian thực, có thể đạt được <strong>hiệu quả tối đa.</strong>',
  },

  func: [
    {
      title: 'Giám sát dây chuyền sản xuất',
      desc: 'Nhanh chóng phát hiện và xử lý các hiện tượng bất thường xảy ra trong quá trình sản xuất, từ đó giảm thiểu sự cố và nâng cao hiệu quả sản xuất.',
      sub1: 'Giám sát tình trạng theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      video: subVideo1,
    },
    {
      title: 'Giảm thiểu hiện tượng tắc nghẽn Bottleneck',
      desc: 'Xác định theo thời gian thực sự di chuyển của nguyên liệu, bán thành phẩm, và thành phẩm để nhận diện giai đoạn nào đang xảy ra tình trạng tắc nghẽn. Ngoài ra, hệ thống còn có thể dự đoán và hỗ trợ đưa ra biện pháp xử lý nhanh chóng.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      video: subVideo2,
    },
    {
      title: 'Quản lý an toàn',
      desc: 'Phát hiện theo thời gian thực các tai nạn xảy ra trên dây chuyền sản xuất. Nhờ đó, có thể ứng phó nhanh chóng ngay từ giai đoạn đầu khi tai nạn xảy ra và ngăn chặn các sự cố nghiêm trọng hơn.',
      sub1: 'Chỉ định đối tượng nguy hiểm',
      icon1: IconWarningGray,
      sub2: 'Thiết lập phương thức ứng phó',
      icon2: IconChartRadiusGray,
      video: subVideo3,
    },
    {
      title: 'Phân tích quy trình',
      desc: 'Thu thập dữ liệu để cải tiến thành một quy trình sản xuất hiệu quả hơn. Dễ dàng xác định các vấn đề tồn tại để thúc đẩy sự phát triển của doanh nghiệp.',
      sub1: 'Lưu trữ dữ liệu trên nền tảng đám mây',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      video: subVideo4,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Hiệu suất của dây chuyền sản xuất là yếu tố cốt lõi trong ngành công nghiệp chế tạo. Các tính năng do Orbro cung cấp có thể nâng cao hơn nữa cả hiệu quả và năng suất của dây chuyền sản xuất.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Có thể tạo báo cáo và tài liệu phân tích dựa trên dữ liệu thu thập từ công trường.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi có sự cố xảy ra trong dây chuyền sản xuất, hệ thống sẽ gửi cảnh báo ngay lập tức để có thể phản ứng kịp thời và ngăn chặn thiệt hại.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lịch sử di chuyển',
        desc: 'Theo dõi và xác định tuyến đường cũng như thời gian di chuyển của vật thể trong khu vực sản xuất để tối ưu hóa quy trình vận hành.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Nắm bắt trạng thái của dây chuyền sản xuất trong thời gian thực để kiểm soát quy trình một cách hiệu quả.',
      },
      {
        icon: IconTemp,
        title: 'Phân tích môi trường như nhiệt độ, độ ẩm',
        desc: 'Giám sát các yếu tố môi trường bên trong kho hoặc khu vực sản xuất và phát hiện bất thường ngay lập tức để duy trì điều kiện hoạt động tối ưu.',
      },
      {
        icon: IconUserCheck,
        title: 'Chỉ thị công việc cho nhân viên',
        desc: 'Dựa trên tình hình thực tế tại hiện trường, hệ thống có thể chỉ định công việc tiếp theo cho người lao động nhằm đảm bảo tiến độ và tính liên tục trong sản xuất.',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'manufacturingSteel' }, { data: 'logisticsAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
